import React from "react";

function BS4_GridExamples() {
  return (
    <div>
      <h1>BS4_GridExamples Component</h1>
      <p>This is the BS4_GridExamples tutorial page content.</p>
    </div>
  );
}

export default BS4_GridExamples;
